// JS
import '../../custom/js/indexOptimized';
import Hero from '../../custom/js/components/hero';
import Home from '../../custom/js/pages/home';
// Base SCSS
import '../../custom/scss/style.scss';

$(() => {
    const hero = new Hero();
    hero.init();

    if ($('.hero--home').length) {
        const home = new Home();
        home.init();
    }
});
